import React from 'react'

import AnimationPlayer from '../../components/AnimationPlayer/AnimationPlayer'
import { Parallax } from 'react-parallax'
import ReactImageAppear from 'react-image-appear'
import lantern from '../../assets/lottie/red-lantern.json'
import { images } from '../../constants'

import './AboutUs.css'

const AboutUs = () => {
  return (
    <Parallax
      bgImage={images.bgMin}
      bgImageStyle={{
        width: '100%',
        height: '100%',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'repeat',
      }}
      bgImageAlt=''
      strength={1000}
      renderLayer={percentage => (
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            background: `linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, ${percentage - 0.2}))`,
            width: '100%',
            height: percentage * 400,
            zIndex: 0,
          }}
        />
      )}
    >
      <div className='app__aboutus flex__center section__padding' id='about'>
        <div className='app__aboutus-content flex__center'>
          <div className='app__aboutus-content_about'>
            <h1 className='headtext__cormorant' style={{ color: 'var(--color-crimson)' }}>
              Kina Grill
            </h1>
            <img src={images.spoon} alt='about_spoon' className='spoon__img' />
            <h1 className='app__aboutus-content_txt'>Hestedamsgade 14, 8700 Horsens</h1>
            <h1 className='app__aboutus-content_txt'>Åbningstider:</h1>
            <p className='p__opensans'>Mandag:</p>
            <p className='p__opensans'>Lukket</p>
            <p className='p__opensans'>Tirsdag - Søndag:</p>
            <p className='p__opensans'>16:00 - 21:00</p>
          </div>

          <div className='app__aboutus-content_lantern flex__center'>
            <AnimationPlayer animation={lantern} width={200} height={200} />
            <div className='lottie-shadow' />
          </div>

          <div className='app__aboutus-content_history'>
            <h1 className='app__aboutus-content_txt'>Nyd maden her eller tag den med hjem</h1>
            <img src={images.spoon} alt='about_spoon' className='spoon__img' />
            <p className='p__opensans'>Køkkenet tilbyder specielle selskabsmenuer efter aftale</p>
          </div>
        </div>
      </div>

      <div className='honeycomb-wrapper'>
        <div className='gallery'>
          {images?.carouselPhotos?.map((photo, i) => (
            <div key={i} className='clipped-border'>
              <ReactImageAppear
                src={photo.fullImage}
                placeholder={photo.placeholder}
                animation='blurIn'
                animationDuration='1s'
                easing='ease-in'
                showLoader={false}
              />
            </div>
          ))}
        </div>
      </div>

      {/* parallax filler content */}
      <div style={{ width: '100%', height: '400px', position: 'relative' }} />
    </Parallax>
  )
}

export default AboutUs
